module.exports = __webpack_public_path__ + "img/6.c1e29f60.png";